export default __webpack_public_path__ + "static/media/filter.781f2f86.svg";